import React, { useEffect, useRef, useState } from "react";
import Orange_Btn from "../../common_btn/orange_btn/Orange_Btn";
import { Form, Modal, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import "./Vendor_Signup_Modal.css";
import {
  faCircleCheck,
  faEye,
  faEyeSlash,
  faPen,
} from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Reset_Password_Modal from "../reset_password_modal/Reset_Password_Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  sendSignupOtp,
  VendorSignUp,
  verifyOtp,
} from "../../../../features/auth/authSlice";

import { myAccount } from "../../../../features/my_account/Slice";
import { getAllCart } from "../../../../features/cart/cartSlice";
import { getAllWishlist } from "../../../../features/wishlist/wishlistSlice";
import Green_btn from "../../common_btn/green_btn/Green_btn";
import { appSetup } from "../../../../features/master/masterSlice";
import Brown_btn from "../../common_btn/brown_btn/Brown_btn";
import { formatCountdown, RegxExpression } from "../../../../utils/common";
import Success_Modal from "../success_modal/Success_Modal";
import Delete_Modal from "../delete_modal/Delete_Modal";
import Blue_Btn from "../../common_btn/blue_btn/Blue_Btn";

const OTP_TIMER = 120;
const Vendor_Signup_Modal = ({ onHide, ...props }) => {
  const [successText, setSuccessText] = useState("");
  const [showSucess, setShowSucess] = useState(false);
  const [showError, setShowError] = useState(false);

  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpCountdown, setOtpCountdown] = useState(0);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    if (otpCountdown <= 0) return;

    const timer = setTimeout(() => {
      setOtpCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [otpCountdown]);

  useEffect(() => {
    if (otpCountdown === 0 && otpSent && !otpVerified) {
      setOtpSent(false);
      setOtp("");
    }
  }, [otpCountdown, otpSent, otpVerified]);

  const modalTimeoutRef = useRef(null);
  const closeMessageModal = () => {
    if (modalTimeoutRef.current) {
      clearTimeout(modalTimeoutRef.current);
    }

    setShowSucess(false);
    setShowError(false);
    setSuccessText("");
  };

  const [password, setPassword] = useState("");

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    watch,
    reset,
    trigger,
  } = useForm({
    defaultValues: {
      re_password: "",
      password: "",
      contact_no: "",
    },
  });

  const dispatch = useDispatch();

  const app_setup = useSelector((state) => state.master.app_setup);

  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const onSubmit = async (data) => {
    if (!otpVerified) {
      setSuccessText("Please verify your email before signing up.");
      setShowError(true);
      return;
    }
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      if (key === "visiting_card_image" || key === "shop_image") {
        formData.append(key, data[key][0]);
      } else {
        formData.append(key, data[key]);
      }
    });

    setSubmitLoading(true);
    let res;
    try {
      res = await dispatch(VendorSignUp(formData));
    } finally {
      setSubmitLoading(false);
    }

    if (res.meta?.requestStatus === "fulfilled") {
      setShowSucess(true);
      setSuccessText(
        res?.payload?.data ||
          "Vendor registration request submitted successfully.",
      );

      // setTimeout(() => {
      //   setShowSucess(false);
      //   setSuccessText("");
      //   onHide?.();
      //   reset();
      // }, 7000);

      modalTimeoutRef.current = setTimeout(() => {
        setShowSucess(false);
        setSuccessText("");
        onHide?.();
        reset();
      }, 5000);
    } else if (res.meta?.requestStatus === "rejected") {
      setSuccessText(res.payload?.errors);
      setShowError(true);
      // setTimeout(() => {
      //   setShowError(false);
      //   setSuccessText("");
      // }, 5000);

      modalTimeoutRef.current = setTimeout(() => {
        setShowError(false);
        setSuccessText("");
      }, 5000);
    } else {
    }
  };

  const visitingCardImage = watch("visiting_card_image");
  const shopImage = watch("shop_image");
  const visitingCardRef = useRef(null);
  const shopImageRef = useRef(null);

  const removeVisitingCardImage = () => {
    setValue("visiting_card_image", null);

    if (visitingCardRef.current) {
      visitingCardRef.current.value = "";
    }
  };

  const removeShopImage = () => {
    setValue("shop_image", null);

    if (shopImageRef.current) {
      shopImageRef.current.value = "";
    }
  };

  useEffect(() => {
    if (!props?.show) {
      reset();
      setOtpSent(false);
      setOtpVerified(false);
      setOtp("");
      setOtpCountdown(0);
    }
  }, [props?.show]);

  useEffect(() => {
    return () => {
      if (modalTimeoutRef.current) {
        clearTimeout(modalTimeoutRef.current);
      }
    };
  }, []);

  const handleChangeEmail = () => {
    setOtpSent(false);
    setOtpVerified(false);
    setOtp("");
    setOtpCountdown(0);
    clearErrors("email");
  };

  const sendOtp = async () => {
    const isValid = await trigger("email");

    if (!isValid) return;

    const email = getValues("email");

    setOtpLoading(true);

    try {
      const res = await dispatch(
        sendSignupOtp({ email, skip_for_customer: true }),
      );

      if (res.meta?.requestStatus === "fulfilled") {
        setOtpSent(true);
        setOtpVerified(false);
        setOtp("");
        setOtpCountdown(OTP_TIMER);

        // setSuccessText(
        //   res?.payload?.data || "OTP sent successfully to your email.",
        // );
        // setShowSucess(true);
      } else {
        setSuccessText(res?.payload?.errors || "Unable to send OTP.");
        setShowError(true);
      }
    } catch (error) {
      setSuccessText(error?.message || "Unable to send OTP.");
      setShowError(true);
    } finally {
      setOtpLoading(false);
    }
  };

  const verifyVendorSignupOtp = async () => {
    if (!otp || otp.length !== 4) {
      setSuccessText("Please enter a valid 4 digit OTP.");
      setShowError(true);
      return;
    }

    const email = getValues("email");

    setOtpLoading(true);

    try {
      const res = await dispatch(verifyOtp({ email, otp }));

      if (res.meta?.requestStatus === "fulfilled") {
        setOtpVerified(true);
        setOtpCountdown(0);

        setSuccessText(res?.payload?.data || "Email verified successfully.");
        setShowSucess(true);
      } else {
        setOtpVerified(false);
        setSuccessText(res?.payload?.errors || "Invalid OTP.");
        setShowError(true);
      }
    } catch (error) {
      setOtpVerified(false);

      setSuccessText(error?.message || "Invalid OTP.");

      setShowError(true);
    } finally {
      setOtpLoading(false);
    }
  };

  return (
    <Modal
      className="Login_Modal Reset_Password_Modal"
      size="md"
      {...props}
      centered
    >
      <Modal.Body>
        <div className="absolute_div vendor_div">
          <div className="logo_holder">
            <img
              // src="/assets/images/logo/new_ekansi_logo.png"
              src={process.env.REACT_APP_IMG_URL + app_setup?.logo}
              className="logo_img"
            />
          </div>
        </div>
        <div className="close_img_div">
          <div className="title_div">
            <p className="title">Vendor Signup Form</p>
          </div>
          <img
            src="/assets/images/modal/close.png"
            className="close_img"
            onClick={onHide}
          />
        </div>

        <div className="signup_div">
          <div className="login_form_div vendor_form">
            <Form>
              <Form.Group className="gray_input_group input_group">
                <Form.Group className="gray_input_group input_group">
                  <Form.Label>Full Name *</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Full name"
                    {...register("name", {
                      required: "Name is required",
                      maxLength: {
                        value: 40,
                        message: "Maximum 40 characters allowed",
                      },
                      pattern: {
                        value: RegxExpression.name,
                        message: "Invalid name ",
                      },
                    })}
                  />
                  {errors?.name && (
                    <sup className="text-danger">{errors?.name?.message}</sup>
                  )}
                </Form.Group>
                <Form.Group className="gray_input_group input_group">
                  <Form.Label>Email *</Form.Label>

                  <div className="email_verify_row">
                    <div className="email_input_wrap">
                      <Form.Control
                        type="email"
                        placeholder="Enter Email ID"
                        readOnly={otpSent || otpVerified}
                        className={otpVerified ? "email_verified_input" : ""}
                        {...register("email", {
                          required: "Email is required",
                          maxLength: {
                            value: 200,
                            message: "Maximum 200 characters allowed",
                          },
                          pattern: {
                            value: RegxExpression.email,
                            message: "Invalid email",
                          },
                        })}
                      />
                      {otpVerified && (
                        <FontAwesomeIcon
                          icon={faCircleCheck}
                          className="email_verified_icon"
                        />
                      )}
                    </div>

                    {otpSent || otpVerified ? (
                      <button
                        type="button"
                        className="email_action_btn change_btn"
                        disabled={otpLoading}
                        onClick={handleChangeEmail}
                      >
                        <FontAwesomeIcon icon={faPen} /> Change
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="email_action_btn send_btn"
                        onClick={sendOtp}
                        disabled={otpLoading}
                      >
                        {otpLoading ? "Sending..." : "Send OTP"}
                      </button>
                    )}
                  </div>

                  {errors?.email && (
                    <sup className="text-danger">{errors.email.message}</sup>
                  )}

                  {otpVerified && (
                    <div className="email_verified_badge">
                      <FontAwesomeIcon icon={faCircleCheck} /> Email verified
                    </div>
                  )}
                </Form.Group>

                {otpSent && otpCountdown > 0 && !otpVerified && (
                  <Form.Group className="gray_input_group input_group">
                    <Form.Label>Enter Email OTP *</Form.Label>

                    <div className="email_verify_row">
                      <div className="email_input_wrap">
                        <Form.Control
                          type="text"
                          placeholder="Enter 4 digit OTP"
                          value={otp}
                          maxLength={4}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            setOtp(value);
                          }}
                        />
                      </div>

                      <button
                        type="button"
                        className="email_action_btn verify_btn"
                        onClick={verifyVendorSignupOtp}
                        disabled={otpLoading || otp.length !== 4}
                      >
                        {otpLoading ? "Verifying..." : "Verify"}
                      </button>
                    </div>

                    {/* Timer */}
                    <div
                      className={`otp_timer_text ${
                        otpCountdown <= 10 ? "expiring" : ""
                      }`}
                    >
                      OTP expires in {formatCountdown(otpCountdown)}
                    </div>
                  </Form.Group>
                )}
              </Form.Group>

              <Form.Group className="gray_input_group input_group">
                <Form.Label>Mobile Number *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter mobile number"
                  maxLength={10}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault(); // Block non-numeric input
                    }
                  }}
                  {...register("contact_no", {
                    required: "Mobile Number is required",
                    minLength: {
                      value: 10,
                      message: "Mobile number must be 10 digits",
                    },
                    maxLength: {
                      value: 10,
                      message: "Mobile number must be 10 digits",
                    },
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Mobile number must be 10 digits",
                    },
                  })}
                />
                {errors?.contact_no && (
                  <sup className="text-danger">
                    {errors?.contact_no?.message}
                  </sup>
                )}
              </Form.Group>

              <Form.Group className="gray_input_group input_group">
                <Form.Label>GST Number *</Form.Label>

                <Form.Control
                  type="text"
                  placeholder="Enter GST Number"
                  style={{ textTransform: "uppercase" }}
                  {...register("gst_number", {
                    required: "GST Number is required",

                    setValueAs: (value) => value.toUpperCase(),

                    maxLength: {
                      value: 15,
                      message: "GST Number must be 15 characters",
                    },

                    pattern: {
                      value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                      message: "Invalid GST Number",
                    },
                  })}
                />

                {errors?.gst_number && (
                  <sup className="text-danger">{errors.gst_number.message}</sup>
                )}
              </Form.Group>

              <Form.Group className="gray_input_group input_group">
                <Form.Label>DL Number (Doctor Licence Number)</Form.Label>

                <Form.Control
                  type="text"
                  placeholder="Enter DL Number"
                  {...register("dl_number", {
                    maxLength: {
                      value: 200,
                      message: "Maximum 200 characters allowed",
                    },
                  })}
                />
                <sup className="text-dark">(Optional)</sup>
                {errors?.dl_number && (
                  <sup className="text-danger">{errors.dl_number.message}</sup>
                )}
              </Form.Group>

              <Form.Group className="gray_input_group input_group mt-3">
                <Form.Label>Visiting Card Image *</Form.Label>

                <Form.Control
                  type="file"
                  accept="image/*"
                  {...register("visiting_card_image", {
                    required: "Visiting card image is required",
                  })}
                  ref={(e) => {
                    register("visiting_card_image").ref(e);
                    visitingCardRef.current = e;
                  }}
                />

                {errors?.visiting_card_image && (
                  <sup className="text-danger">
                    {errors.visiting_card_image.message}
                  </sup>
                )}

                {visitingCardImage?.[0] && (
                  <div
                    className="mt-3 position-relative d-inline-block"
                    style={{ width: "150px" }}
                  >
                    <img
                      src="/assets/images/modal/close.png"
                      alt="Remove"
                      className="image_position_absolute"
                      onClick={removeVisitingCardImage}
                    />

                    <img
                      src={URL.createObjectURL(visitingCardImage[0])}
                      alt="Visiting Card Preview"
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                      }}
                    />
                  </div>
                )}
              </Form.Group>

              {/* Shop Image */}
              <Form.Group className="gray_input_group input_group mt-3">
                <Form.Label>Image of Shop *</Form.Label>

                <Form.Control
                  type="file"
                  accept="image/*"
                  {...register("shop_image", {
                    required: "Shop image is required",
                  })}
                  ref={(e) => {
                    register("shop_image").ref(e);
                    shopImageRef.current = e;
                  }}
                />

                {errors?.shop_image && (
                  <sup className="text-danger">{errors.shop_image.message}</sup>
                )}

                {shopImage?.[0] && (
                  <div
                    className="mt-3 position-relative d-inline-block"
                    style={{ width: "150px" }}
                  >
                    <img
                      src="/assets/images/modal/close.png"
                      alt="Remove"
                      className="image_position_absolute"
                      onClick={removeShopImage}
                    />

                    <img
                      src={URL.createObjectURL(shopImage[0])}
                      alt="Shop Preview"
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                      }}
                    />
                  </div>
                )}
              </Form.Group>

              <Form.Group className="gray_input_group input_group">
                <Form.Label className="label_text"> Password *</Form.Label>
                <div className="password_holder">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    name="password"
                    {...register("password", {
                      required: "Password is required",

                      minLength: {
                        value: 8,
                        message: "Password must be at least 8 characters long",
                      },

                      pattern: {
                        value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&]).{8,}$/,
                        message:
                          "Password must be at least 8 characters and contain uppercase, lowercase, number, and special character",
                      },
                    })}
                    placeholder="Enter Password"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  {errors?.password && (
                    <sup className="text-danger">
                      {errors?.password?.message}
                    </sup>
                  )}
                  <div className="eye-icc">
                    <FontAwesomeIcon
                      icon={iconOne}
                      className="icon"
                      onClick={() => togglePasswordVisibility("password")}
                    />
                  </div>
                </div>
              </Form.Group>

              <Form.Group className="gray_input_group input_group">
                <Form.Label className="label_text">
                  {" "}
                  Confirm Password *
                </Form.Label>
                <div className="password_holder">
                  <Form.Control
                    type={showPasswordOne ? "text" : "password"}
                    name="re_password"
                    {...register("re_password", {
                      required: "Re-Enter Password  is required",
                    })}
                    placeholder="Enter Password"
                    onChange={(e) => setPasswordAgain(e.target.value)}
                  />

                  <div className="eye-icc">
                    <FontAwesomeIcon
                      icon={iconTwo}
                      className="icon"
                      onClick={() =>
                        togglePasswordVisibility("reenterPassword")
                      }
                    />
                  </div>
                  {errors?.re_password && (
                    <sup className="text-danger">
                      {errors?.re_password?.message}
                    </sup>
                  )}
                </div>
              </Form.Group>

              {password && (
                <div className="password_check_list">
                  <PasswordChecklist
                    rules={[
                      "minLength",
                      "specialChar",
                      "number",
                      "capital",
                      "match",
                    ]}
                    minLength={8}
                    value={password}
                    valueAgain={passwordAgain}
                    onChange={(isValid) => {}}
                    style={{
                      fontSize: "10px",
                      padding: "4px",
                      margin: "0",
                    }}
                  />
                </div>
              )}
            </Form>
          </div>

          <div className="btn_holder">
            <div
              style={
                submitLoading ? { pointerEvents: "none", opacity: 0.7 } : {}
              }
            >
              <Brown_btn
                btnText={
                  submitLoading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Signing Up...
                    </>
                  ) : (
                    "Sign Up"
                  )
                }
                disabled={submitLoading}
                onClick={handleSubmit(onSubmit)}
              />
            </div>
          </div>
        </div>
      </Modal.Body>

      <Success_Modal
        show={showSucess}
        onHide={() => {
          setShowSucess(false);
        }}
        successText={successText}
      />

      <Delete_Modal
        show={showError}
        onHide={() => {
          setShowError(false);
        }}
        successText={successText}
      />
    </Modal>
  );
};

export default Vendor_Signup_Modal;
